export const MARKET_DATA_REFRESH = 15000;
export const USER_BALANCE_REFRESH = 30000;
export const USER_ALL_MARGINS_REFRESH = 50000;
export const PYTH_PRICE_DATA_REFRESH = 1500;
export const STABLES_PRICE_DATA_REFRESH_MATCHA = 100000;
export const USER_TRADING_SEASON_STATS_REFRESH = 10000;

export const TRADING_SEASON_DATA_REFRESH = 30000;
export const PRESENCE_API_REFRESH = 10000;
